import React, { type PropsWithChildren } from 'react';
import toolbarStyles from '../../components/Toolbar/Toolbar.module.css';
import type Tool from '../../tools/Tool';
import { type ToolArgsWithController } from '../../tools/Tool';
import classnames from 'classnames';

interface ElementToolbarButtonProps {
  tool: typeof Tool;
  toolArgs: ToolArgsWithController;
  onClick?: (event: React.MouseEvent) => void;
  onMouseDown?: (event: React.MouseEvent) => void;
}

const ElementToolbarButtonWithRef = React.forwardRef<
  HTMLDivElement,
  PropsWithChildren<ElementToolbarButtonProps>
>(function ElementToolbarButton(
  { tool, toolArgs, onClick, onMouseDown, children },
  ref
) {
  const enabled = tool.isEnabled(toolArgs);
  const active = tool.isActive(toolArgs);

  const ariaAttributes: any = {
    'aria-label': tool.toolName,
  };
  if (!enabled) {
    ariaAttributes['aria-disabled'] = true;
  }
  if (active) {
    ariaAttributes['aria-selected'] = true;
  }

  return (
    <div
      className={classnames(
        toolbarStyles.toolbarButton,
        toolbarStyles.elementToolbarButton
      )}
      role="button"
      ref={ref}
      data-testid={`tool-${tool.name}`}
      onClick={onClick}
      onMouseDown={onMouseDown}
      {...ariaAttributes}
      inert={!enabled ? 'true' : undefined} // Disable click event if not enabled. Otherwise a button click action can still take place.
    >
      {children}
    </div>
  );
});

export default ElementToolbarButtonWithRef;
